<template>
  <body>
    <Header></Header>
    <img src="icon_common.png" class="logo" height="50px" width="50px" />
    <img src="icon_director.png" class="logo2" height="50px" width="50px" />
    <img src="icon_cast.png" class="logo3" height="50px" width="50px" />
    <span class="title">Common Features</span>
    <div class="part">
      <div class="box" style="background-color: #272727">
        <h1>Stereotype or Common Features?</h1>
        <h2>
          TV plays and Movies are under rating system. Which type of videos has
          the most collection in Netflex? And is there any stereotyped setting
          and plot in these rated videos? The following word cloud charts are
          generated by brief descriptions of Netflex videos. Click the left side
          ratings to retrieve different word clouds for its corresponding common
          plot-features.
        </h2>
        <h2>
          Let's explore what the frequent words varied in different rating
          categories
        </h2>
      </div>
      <br />
      <div style="cursor: pointer">
        <div>
          <svg class="svgchart" id="chart3"></svg>
          <svg class="svgchart" id="chart4"></svg>
        </div>
        <br />
        <br />

        <div class="box" style="background-color: #272727">
          <h1>Oscar or Razzie?</h1>
          <h2>
            Which directors' and which actors/actresses' movies are collected by
            Netflix mostly? Is there anyone you are familiar with? Or all of
            casts are strange faces? Should Netflix need to collect more videos
            produced by celebrities or superstars?
          </h2>
          <h2>You may get your answer with the following word charts.</h2>
          <br />
        </div>
        <div>
          <svg class="svgchart" id="chart5"></svg>
          <svg class="svgchart" id="chart6"></svg>
        </div>
      </div>
    </div>
    <router-link to="/mapbox" @click.native="scrollToTop">
      <div class="next">
        <img src="next.png" height="50px" width="50px" />
      </div>
    </router-link>
  </body>
</template>

<script>
/* eslint-disable */
import Header from "@/components/Header";
import * as d3 from "d3";
import * as d3_cloud from "d3-cloud";
// import d3 from "@/assets/d3/index.js"

export default {
  name: "cloud",
  components:{
    Header
  },
  data: function () {
    return {
      netflix_titles: null,
      netflix_titles2: null,
      netflix_titles3: null,
    };
  },
  mounted: function () {
    console.log("mounted");

    if (!this.$store.state.netflix_titles) {
      d3.csv("netflix_titles.csv", (d) => {
        return {
          id: d.show_id,
          rating: d.rating,
          description: d.description,
        };
      }).then((data) => {
        this.netflix_titles = data;
        // console.log("chartData set from file");
        // console.log("chartData contains", this.chartData.length, "rows");
        this.$store.commit("netflix_titles", this.netflix_titles);
        this.cloud();
      });
    } else {
      this.netflix_titles = this.$store.state.netflix_titles;
      //console.log("chartData set from store");
      //console.log("chartData contains", this.sunburst_data.length, "rows");
      this.cloud();
    }

    if (!this.$store.state.netflix_titles2) {
      d3.csv("netflix_titles.csv", (d) => {
        return {
          id: d.show_id,
          rating: d.rating,
          director: d.director,
          cast: d.cast,
        };
      }).then((data) => {
        this.netflix_titles2 = data;
        // console.log("chartData set from file");
        // console.log("chartData contains", this.chartData.length, "rows");
        this.$store.commit("netflix_titles2", this.netflix_titles2);
        this.cloud2();
      });
    } else {
      this.netflix_titles2 = this.$store.state.netflix_titles2;
      //console.log("chartData set from store");
      //console.log("chartData contains", this.sunburst_data.length, "rows");
      this.cloud2();
    }

    if (!this.$store.state.netflix_titles3) {
      d3.csv("netflix_titles.csv", (d) => {
        return {
          id: d.show_id,
          rating: d.rating,
          cast: d.cast,
        };
      }).then((data) => {
        this.netflix_titles3 = data;
        // console.log("chartData set from file");
        // console.log("chartData contains", this.chartData.length, "rows");
        this.$store.commit("netflix_titles3", this.netflix_titles3);
        this.cloud3();
      });
    } else {
      this.netflix_titles3 = this.$store.state.netflix_titles3;
      //console.log("chartData set from store");
      //console.log("chartData contains", this.sunburst_data.length, "rows");
      this.cloud3();
    }
  },
  methods: {
    /* eslint-disable */
    scrollToTop() {
      window.scrollTo(0, 0);
    },

    cloud() {
      /*<- ->*/
      const fontFamily = "Verdana, Arial, Helvetica, sans-serif";

      var width = window.innerWidth * 0.48;
      var height = 400;
      //console.log(window.innerHeight);
      var svg3 = d3
        .select("#chart3")
        .attr("width", width)
        .attr("height", height)
        .attr("viewBox", [0, 0, width, height])
        .attr("font-family", fontFamily)
        .attr("text-anchor", "middle");
      var svg4 = d3
        .select("#chart4")
        .attr("width", width)
        .attr("height", height);
      var tally = {};
      var dataset = [];

      var data = this.netflix_titles;
      data.forEach(function (obj, i) {
        rating = obj.rating;
        tally[rating] = (tally[rating] || 0) + 1;
      });

      for (var rating in tally) {
        if (tally.hasOwnProperty(rating)) {
          dataset.push({
            text: rating,
            value: tally[rating],
          });
        }
      }
      //console.log(dataset);

      var data1 = dataset;
      var s = d3
        .scaleSqrt()
        .domain([1, d3.max(data1.map((d) => d.value))])
        .range([6, 82]);

      const displaySelection = svg3
        .append("text")
        .attr("font-family", "Lucida Console, Courier, monospace")
        .attr("text-anchor", "start")
        .attr("alignment-baseline", "hanging")
        .attr("x", 10)
        .attr("y", 380)
        .attr("font-size", 10)
        .style("fill", "white");

      var Tooltip = svg3
        .append("div")
        .style("opacity", 0)
        .attr("class", "tooltip")
        .style("background-color", "white")
        .style("border", "solid")
        .style("border-width", "2px")
        .style("border-radius", "5px")
        .style("padding", "5px");

      const cloud = d3_cloud()
        .size([width, height])
        .words(data1.map((d) => Object.create(d)))
        .padding(1)
        .rotate(() => 0)
        .font(fontFamily)
        .fontSize((d) => s(d.value / 3))
        .on("word", ({ size, x, y, rotate, text }) => {
          //console.log(text);
          svg3
            .append("text")
            .attr("font-size", size)
            .attr("transform", `translate(${x},${y}) rotate(${rotate})`)
            .text(text)
            .classed("click-only-text", true)
            .classed("word-default", true)
            .style("fill", "#ececec")
            .on("mouseover", handleMouseOver)
            .on("mouseout", handleMouseOut)
            .on("click", handleClick);

          function handleMouseOver(d, i, size) {
            d3.select(this)
              .classed("word-hovered", true)
              .transition(`mouseover-${text}`)
              .duration(300)
              .ease(d3.easeLinear)
              .attr("font-size", size + 3)
              .attr("font-weight", "bold");
            var e = d3.select(this);
            displaySelection.text(
              `Click to show the most common features in "${e.text()}" `
            );
          }

          function handleMouseOut(d, i) {
            d3.select(this)
              .classed("word-hovered", false)
              .interrupt(`mouseover-${text}`)
              .attr("font-size", size);
          }

          function handleClick(d, i) {
            d3.select("#chart4").selectAll("*").remove();
            var e = d3.select(this);
            displaySelection.text(
              `The Font-size for each word is proportional to its popularity"`
            );
            e.classed("word-selected", !e.classed("word-selected"));
            //////////////
            var svg4 = d3
              .select("#chart4")
              .attr("width", width)
              .attr("height", height)
              .attr("viewBox", [0, 0, width, height])
              .attr("font-family", fontFamily)
              .attr("text-anchor", "middle");

            var tally2 = {};
            var dataset2 = [];

            //console.log(text);

            var filterdata = data.filter(function (d) {
              if (d["rating"] == text) {
                return d;
              }
            });
            //console.log(filterdata);
            var wordlist = [];

            filterdata.forEach(function (obj, i) {
              wordlist = wordlist + obj.description;
            });
            //console.log(wordlist);

            var adjustedword = wordlist
              .split(/[\s.]+/g)
              .map((w) => w.replace(/^[“‘"\-—()\[\]{}]+/g, ""))
              .map((w) => w.replace(/[;:.!?()\[\]{},"'’”\-—]+$/g, ""))
              .map((w) => w.replace(/['’]s$/g, ""))
              .map((w) => w.substring(0, 30))
              .map((w) => w.toLowerCase());
            //.filter(w => w && !stopwords.has(w));

            //console.log(adjustedword);
            var data3 = d3
              .rollups(
                adjustedword,
                (group) => group.length,
                (w) => w
              )
              .sort(([, a], [, b]) => d3.descending(a, b))
              .slice(0, 250)
              .filter(([text3, value3]) => value3 > 1)
              .filter(([text3, value3]) => text3.length > 5)
              .map(([text3, value3]) => ({ text3, value3 }));
            console.log(data3);

            var s = d3
              .scaleSqrt()
              .domain([1, d3.max(data3.map((d) => d.value3))])
              .range([6, 82]);

            const displaySelection2 = svg4
              .append("text")
              .attr("font-family", "Lucida Console, Courier, monospace")
              .attr("text-anchor", "start")
              .attr("alignment-baseline", "hanging")
              .attr("x", 400)
              .attr("y", 380)
              .attr("font-size", 10)
              .style("fill", "white");

            var fill = [
              "#1f77b4",
              "#ff7f0e",
              "#2ca02c",
              "#d62728",
              "#9467bd",
              "#8c564b",
              "#e377c2",
              "#7f7f7f",
              "#bcbd22",
              "#17becf",
            ];

            var subcloud = d3_cloud()
              .size([400, 400])
              .words(data3.map((d) => Object.create(d)))
              .padding(1)
              .rotate(() => 0)
              .font(fontFamily)
              .fontSize((d) => s(d.value3 / 4))
              .on("word", ({ size, x, y, rotate, text3 }) => {
                svg4
                  .append("text")
                  .attr("font-size", size)
                  .attr("transform", `translate(${x},${y}) rotate(${rotate})`)
                  .text(text3)
                  .style("fill", fill[Math.floor(Math.random() * 9)])
                  .classed("click-only-text", true)
                  .classed("word-default", true)
                  .on("mouseover", handleMouseOver2)
                  .on("mouseout", handleMouseOut2)
                  .on("click", handleClick2);

                function handleMouseOver2(d, i) {
                  d3.select(this)
                    .classed("word-hovered", true)
                    .transition(`mouseover-${text3}`)
                    .duration(300)
                    .ease(d3.easeLinear)
                    .attr("font-size", size + 3)
                    .attr("font-weight", "bold");
                  var e = d3.select(this);
                  displaySelection2.text(`Click words to clear "pad"`);
                }

                function handleMouseOut2(d, i) {
                  d3.select(this)
                    .classed("word-hovered", false)
                    .interrupt(`mouseover-${text3}`)
                    .attr("font-size", size);
                }

                function handleClick2(d, i) {
                  var e = d3.select(this);
                  e.classed("word-selected", !e.classed("word-selected"));
                  //console.log(e.text())
                  d3.select("#chart4").selectAll("*").remove();
                }
              });
            subcloud.start();

            /////////////////////////
          }
        });

      cloud.start();
    },
    cloud2() {
      const fontFamily = "Verdana, Arial, Helvetica, sans-serif";
      var width = window.innerWidth * 0.48;
      var height = 400;
      var svg5 = d3
        .select("#chart5")
        .attr("width", width)
        .attr("height", height)
        .attr("viewBox", [0, 0, width, height])
        .attr("font-family", fontFamily)
        .attr("text-anchor", "middle");

      var tally = {};
      var dataset = [];

      var data = this.netflix_titles2;
      var directorlist = [];

      data.forEach(function (obj, i) {
        directorlist = directorlist + obj.director;
      });
      //console.log(wordlist);

      var directors = directorlist
        .split(",")
        .map((w) => w.replace(/^[“‘"\-—()\[\]{}]+/g, ""))
        .map((w) => w.replace(/[;:.!?()\[\]{},"'’”\-—]+$/g, ""))
        .map((w) => w.replace(/['’]s$/g, ""))
        .map((w) => w.substring(0, 20))
        .map((w) => w.toLowerCase());
      //console.log(directors);
      var data5 = d3
        .rollups(
          directors,
          (group) => group.length,
          (w) => w
        )
        .sort(([, a], [, b]) => d3.descending(a, b))
        .slice(0, 250)
        .filter(([text, value]) => value > 1)
        //.filter(([text, value]) => text.length > 5)
        .map(([text, value]) => ({ text, value }));
      console.log(data5);

      var s = d3
        .scaleSqrt()
        .domain([1, d3.max(data5.map((d) => d.value))])
        .range([6, 82]);

      const displaySelection3 = svg5
        .append("text")
        .attr("font-family", "Lucida Console, Courier, monospace")
        .attr("text-anchor", "start")
        .attr("alignment-baseline", "hanging")
        .attr("x", 5)
        .attr("y", 5)
        .attr("font-size", 3);
      var fill = [
        "#1f77b4",
        "#ff7f0e",
        "#2ca02c",
        "#d62728",
        "#9467bd",
        "#8c564b",
        "#e377c2",
        "#7f7f7f",
        "#bcbd22",
        "#17becf",
      ];

      const directorcloud = d3_cloud()
        .size([width, height])
        .words(data5.map((d) => Object.create(d)))
        .padding(1)
        .rotate((d) => ~~(Math.random() * 2) * 90)
        .font(fontFamily)
        .fontSize((d) => s(d.value))
        .on("word", ({ size, x, y, rotate, text }) => {
          svg5
            .append("text")
            .attr("font-size", size)
            .attr("transform", `translate(${x},${y}) rotate(${rotate})`)
            .text(text)
            .style("fill", fill[Math.floor(Math.random() * 9)])
            .classed("click-only-text", true)
            .classed("word-default", true)
            .on("mouseover", handleMouseOver)
            .on("mouseout", handleMouseOut)
            .on("click", handleClick);

          function handleMouseOver(d, i) {
            d3.select(this)
              .classed("word-hovered", true)
              .transition(`mouseover-${text}`)
              .duration(300)
              .ease(d3.easeLinear)
              .attr("font-size", size + 3)
              .attr("font-weight", "bold");
            var e = d3.select(this);
            displaySelection3.text(`selection="${e.text()}"`);
          }

          function handleMouseOut(d, i) {
            d3.select(this)
              .classed("word-hovered", false)
              .interrupt(`mouseover-${text}`)
              .attr("font-size", size);
          }

          function handleClick(d, i) {
            var e = d3.select(this);
            e.classed("word-selected", !e.classed("word-selected"));
            console.log(e.text());
          }
        });
      directorcloud.start();
    },
    cloud3() {
      const fontFamily = "Verdana, Arial, Helvetica, sans-serif";
      var width = window.innerWidth * 0.48;
      var height = 400;
      var svg6 = d3
        .select("#chart6")
        .attr("width", width)
        .attr("height", height)
        .attr("viewBox", [0, 0, width, height])
        .attr("font-family", fontFamily)
        .attr("text-anchor", "middle");

      var data = this.netflix_titles3;
      var castlist = [];

      data.forEach(function (obj, i) {
        castlist = castlist + obj.cast;
      });
      //console.log(wordlist);

      var casts = castlist
        .split(",")
        .map((w) => w.replace(/^[“‘"\-—()\[\]{}]+/g, ""))
        .map((w) => w.replace(/[;:.!?()\[\]{},"'’”\-—]+$/g, ""))
        .map((w) => w.replace(/['’]s$/g, ""))
        .map((w) => w.substring(0, 30))
        .map((w) => w.toLowerCase());
      //console.log(casts);
      var data6 = d3
        .rollups(
          casts,
          (group) => group.length,
          (w) => w
        )
        .sort(([, a], [, b]) => d3.descending(a, b))
        .slice(0, 250)
        .filter(([text, value]) => value > 1)
        .filter(([text, value]) => text.length > 5)
        .map(([text, value]) => ({ text, value }));
      //console.log(data6);

      var s = d3
        .scaleSqrt()
        .domain([1, d3.max(data6.map((d) => d.value))])
        .range([6, 82]);

      const displaySelection4 = svg6
        .append("text")
        .attr("font-family", "Lucida Console, Courier, monospace")
        .attr("text-anchor", "start")
        .attr("alignment-baseline", "hanging")
        .attr("x", 5)
        .attr("y", 5)
        .attr("font-size", 3);
      var fill = [
        "#1f77b4",
        "#ff7f0e",
        "#2ca02c",
        "#d62728",
        "#9467bd",
        "#8c564b",
        "#e377c2",
        "#7f7f7f",
        "#bcbd22",
        "#17becf",
      ];

      const castcloud = d3_cloud()
        .size([width, height])
        .words(data6.map((d) => Object.create(d)))
        .padding(1)
        .rotate((d) => ~~(Math.random() * 2) * 90)
        .font(fontFamily)
        .fontSize((d) => s(d.value / 4))
        .on("word", ({ size, x, y, rotate, text }) => {
          svg6
            .append("text")
            .attr("font-size", size)
            .attr("transform", `translate(${x},${y}) rotate(${rotate})`)
            .text(text)
            .style("fill", fill[Math.floor(Math.random() * 9)])
            .classed("click-only-text", true)
            .classed("word-default", true)
            .on("mouseover", handleMouseOver)
            .on("mouseout", handleMouseOut)
            .on("click", handleClick);

          function handleMouseOver(d, i) {
            d3.select(this)
              .classed("word-hovered", true)
              .transition(`mouseover-${text}`)
              .duration(300)
              .ease(d3.easeLinear)
              .attr("font-size", size + 3)
              .attr("font-weight", "bold");
            var e = d3.select(this);
            displaySelection4.text(`selection="${e.text()}"`);
          }

          function handleMouseOut(d, i) {
            d3.select(this)
              .classed("word-hovered", false)
              .interrupt(`mouseover-${text}`)
              .attr("font-size", size);
          }

          function handleClick(d, i) {
            var e = d3.select(this);
            e.classed("word-selected", !e.classed("word-selected"));
            console.log(e.text());
          }
        });
      castcloud.start();
    },
  },
};
</script>

<style scoped>
body {
  font-family: "Lato", sans-serif;
  font-size: 16px;
  font-weight: normal;
  color: #555;
  background-color: #121212;
  height: 240vh;
}
.title {
  position: absolute;
  color: rgba(255, 255, 255, 0.781);
  font-size: 25px;
  top: 13.5%;
  left: 18%;
}
.logo {
  position: absolute;
  top: 12%;
  left: 2%;
}
.logo2 {
  position: absolute;
  top: 12%;
  left: 7%;
}
.logo3 {
  position: absolute;
  top: 12%;
  left: 12%;
}

h1 {
  padding: 10px;
  margin: 20px 0px 0px 0px;
  color: #a6effe;
  font-weight: bold;
  font-size: 25px;
  text-decoration: underline;
}

h2 {
  padding: 10px;
  margin: 20px 0px 0px 0px;
  color: #a6effe;
  /* color: white; */
  font-size: 15px;
}

cap {
  display: block;
  font-size: 0.75em;
  font-style: italic;
  color: #777;
  margin-bottom: 5px;
  text-decoration: underline;
}

>>> .sample {
  border: 2px dotted lightgrey;
  padding: 10px;
}

>>> .answer {
  border: 2px solid lightgrey;
  margin: 20px 0px;
  padding: 10px;
}

>>> .nb {
  font-size: 0.75em;
  color: #888;
}

>>> kbd {
  font-family: monospace;
}

>>> .alert {
  border-radius: 3px;
  background-color: rgb(248, 248, 248);
  padding: 5px;
  margin: 5px;
  font-size: 0.85em;
  color: #666;
  text-align: left;
  display: inline-block;
}

>>> .info {
  background-color: rgb(243, 248, 250);
}

>>> .warning {
  background-color: rgb(253, 248, 243);
}

>>> .danger {
  background-color: rgb(254, 246, 246);
}

>>> .container {
  display: flex;
}

>>> .col {
  flex: 1;
}

>>> .col-2 {
  flex: 2;
}

>>> .col-3 {
  flex: 3;
}

>>> .col-4 {
  flex: 3;
}

>>> .svg-container {
  display: inline-block;
  position: relative;
  width: 100%;
  padding-bottom: 100%; /* aspect ratio */
  vertical-align: top;
  overflow: hidden;
  border-radius: 15%;
}
>>> .svg-content-responsive {
  display: inline-block;
  position: absolute;
  top: 10px;
  left: 0;
}

>>> svg .rect {
  fill: gold;
  stroke: steelblue;
  stroke-width: 5px;
}

>>> .axis line {
  stroke: #706f6f;
  stroke-width: 0.5;
  shape-rendering: crispEdges;
}

/* axis contour */
>>> .axis path {
  stroke: #706f6f;
  stroke-width: 0.7;
  shape-rendering: crispEdges;
}

/* axis text */
>>> .axis text {
  fill: #2b2929;
  font-family: Georgia;
  font-size: 120%;
}

/* LINE CHART */
>>> path.line-0 {
  fill: none;
  stroke: #ed3700;
}

>>> path.line-1 {
  fill: none;
  stroke: #2b2929;
  stroke-dasharray: 2;
}

>>> path.line-2 {
  fill: none;
  stroke: #9c9c9c;
  stroke-dasharray: 6;
}

>>> .serie_label {
  fill: #2b2929;
  font-family: Georgia;
  font-size: 80%;
}

>>> .click-only-text {
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
>>> .click-only-text::selection {
  background: none;
}

>>> .word-default {
  fill: cadetblue;
  font-weight: normal;
}
>>> .word-hovered {
  fill: teal;
  font-weight: bold;
}
>>> .word-selected {
  fill: darkslategrey;
  font-weight: bold;
}

>>> .box {
  padding: 10px;
  margin-bottom: 10px;
  text-align: left;
  border-radius: 15px;
}
>>> .svgchart {
  text-align: center;
  border-radius: 15px;
  background-color: #272727;
}
.part{
  position: absolute;
  top: 20%;
  padding: 1.8%;

}
.next {
  position: absolute;
  left: 48%;
  top: 225%;
}
</style>